"use client";

import * as React from "react";
import { Play, Radio } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VideoLiveUtama() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="video-live-utama" className="bg-sidebar-foreground py-12 sm:py-16 lg:py-24 overflow-hidden">
      <div className="container mx-auto px-4 max-w-6xl">
        <div ref={ref} className="transition-opacity duration-[600ms] ease-in-out" style={{
        opacity: isVisible ? 1 : 0
      }}>
          {}
          <AspectRatio ratio={16 / 9} className="bg-black rounded-sm sm:rounded-md lg:rounded-lg overflow-hidden relative group shadow-xl sm:shadow-2xl">
            {}
            <Badge variant="default" className="absolute top-3 left-3 sm:top-4 sm:left-4 lg:top-6 lg:left-6 z-20 animate-pulse bg-primary text-primary-foreground hover:bg-primary border-none shadow-lg px-2 py-1 sm:px-3 sm:py-1.5 lg:px-4 lg:py-2 text-xs sm:text-sm lg:text-base tracking-wide font-bold">
              <Radio className="mr-2 size-4" />
              LIVE
            </Badge>

            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/cinematic_live_event_thumbnail.png" alt="Live Event Stream" className="object-cover w-full h-full opacity-70 transition-transform duration-700 group-hover:scale-105" />

            {}
            <div className="absolute inset-0 bg-gradient-to-t from-sidebar-foreground/90 via-sidebar-foreground/20 to-transparent z-10 pointer-events-none" />

            {}
            <div className="absolute inset-0 flex items-center justify-center z-20">
              <Button size="icon" className="rounded-full size-16 sm:size-20 lg:size-28 bg-primary/90 hover:bg-primary text-primary-foreground shadow-[0_0_40px_rgba(235,124,45,0.4)] transition-transform hover:scale-110" aria-label="Play Live Video">
                <Play className="size-8 sm:size-10 lg:size-14 ml-1.5 fill-current" />
              </Button>
            </div>
          </AspectRatio>

          {}
          <div className="mt-10 flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl leading-tight font-bold text-primary-foreground font-sans max-w-3xl tracking-tight">
              Video Live Utama
            </h1>
            <Link to="#">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-sm sm:text-base lg:text-lg px-6 sm:px-8 lg:px-10 h-12 sm:h-14 lg:h-16 font-semibold shadow-lg">
                Tonton Sekarang
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}